import { moneyField } from 'src/lib/ValidatorHelper';
import * as Yup from 'yup';

const FundraisingMatchingValidator = () => Yup.object().shape({
  show_raised_amount: Yup.boolean(),
  //
  show_goal: Yup.boolean(),
  goal: moneyField().when('show_goal', {
    is: true,
    then: (schema) => schema.required('Admin fee is required'),
    otherwise: (schema) => schema,
  }),
  //
  bonus_round_active: Yup.boolean(),
  bonus_round_goal: moneyField().when('bonus_round_active', {
    is: true,
    then: (schema) => schema.required('Admin fee is required'),
    otherwise: (schema) => schema,
  }),
  bonus_round_multiplier: moneyField(),
  active_matching: Yup.boolean(),
  start_amount_multiplier: Yup.number().when('active_matching', {
    is: true,
    then: (schema) => schema.required('????'),
    otherwise: (schema) => schema,
  }),
  end_amount_multiplier: moneyField().when('active_matching', {
    is: true,
    then: (schema) => schema.required('!!!!!'),
    otherwise: (schema) => schema,
  }),
});

export default FundraisingMatchingValidator;
